import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultarBloqueioDetranRenajud } from './types';

export const INITIAL_STATE: consultarBloqueioDetranRenajud = {
	status: 0,
	data: {
		bloqueioDetran: null,
		bloqueioRenajud: null,
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarBloqueioDetranRenajud {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_BLOQUEIO_DETRAN_RENAJUD_REQUEST: {
				break;
			}

			case Types.CONSULTAR_BLOQUEIO_DETRAN_SUCCESS: {
				draft.status = 200;
				draft.data.bloqueioDetran = action.payload;
				break;
			}

			case Types.CONSULTAR_BLOQUEIO_RENAJUD_SUCCESS: {
				draft.status = 200;
				draft.data.bloqueioRenajud = action.payload;
				break;
			}

			case Types.CONSULTAR_BLOQUEIO_DETRAN_RENAJUD_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_BLOQUEIO_DETRAN_RENAJUD_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
